import moment from 'moment';
import store from '@/store';

export const secondsToDays = (seconds) => {
  return Math.floor(seconds / 86400);
};

export const daysToSeconds = (days) => {
  return days * 24 * 60 * 60;
};

export const secondsToHours = (seconds) => {
  return Math.floor(seconds / 3600);
};

export const hoursToSeconds = (hours) => {
  return hours * 3600;
};

export const secondsToDaysTokens = (seconds) => {
  return { days: Math.floor(seconds / 86400), residueSeconds: seconds % 86400 };
};

export const calculateBeginTime = (startSeconds) => {
  const onlyTime = startSeconds % 86400;
  const duration = moment.duration(startSeconds, 'seconds');
  let hours = duration.hours();
  let minutes = duration.minutes();
  return `${hours}:${minutes}`;
};

export const timeToSeconds = (time) => {
  if (time) {
    const date = moment(time, 'H : mm A');
    const seconds = date.hours() * 3600 + date.minutes() * 60 + date.seconds();
    return seconds < 0 ? seconds + 86400 : seconds;
  }
  return 0;
};

export const secondsToTime = (seconds) => {
  const date = new Date(seconds * 1000);
  let numberHours = date.getUTCHours();
  numberHours = numberHours > 12 ? numberHours - 12 : numberHours;
  const hours = numberHours < 10 ? `0${numberHours}` : numberHours + '';
  const suffix = date.getUTCHours() < 12 ? 'am' : 'pm';
  const minutes = date.getUTCMinutes() < 10 ? `0${date.getUTCMinutes()}` : date.getUTCMinutes() + '';
  return `${hours}:${minutes} ${suffix}`;
};

export const secondsToDuration = (val, type) => {
  let seconds = 0;

  switch (type) {
    case 'minutes':
      seconds = val * 60;
      break;
    case 'hours':
      seconds = 3600 * val;
      break;
    default:
      seconds = val;
  }

  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  hours = hours < 10 ? `0${hours}` : hours + '';
  minutes = minutes < 10 ? `0${minutes}` : minutes + '';
  return `${hours}h ${minutes}m`;
};

export const jsonToSeconds = (json) => {
  switch (json.units) {
    case 'hours':
      return json.number * 3600;
    case 'minutes':
      return json.number * 60;
    case 'seconds':
      return json.number;
  }
  return 0;
};

export const timeToFullStr = (val) => {
  if (!val) {
    return '00';
  }

  if (val < 10) {
    return `0${val}`;
  }

  return (val = `${val}`);
};

export const convertUTCTime = (time, inputFormat = 'HH:mm') => {
  const userInfo = JSON.parse(window.localStorage.getItem('user'));
  if (userInfo.timePreference && Number(userInfo.timePreference) === 12) {
    return moment.utc(time, inputFormat).add(store.getters.getUser.facility_UTCOffset, 'hours');
  } else {
    return moment.utc(time, inputFormat).local();
  }
};

export const convertUTCTimeToUserPreference = (time, inputFormat = 'HH:mm') => {
  const userInfo = JSON.parse(window.localStorage.getItem('user'));
  if (userInfo.timePreference && Number(userInfo.timePreference) === 12) {
    return moment.utc(time, inputFormat).add(store.getters.getUser.facility_UTCOffset, 'hours');
  } else {
    return moment.utc(time, inputFormat).local();
  }
};

export const convertFacilityTimeToUserPreference = (time, inputFormat = 'HH:mm') => {
  const userInfo = JSON.parse(window.localStorage.getItem('user'));
  if (userInfo.timePreference && Number(userInfo.timePreference) === 12) {
    return moment(time, inputFormat);
  } else {
    const localUTCOffset = moment().utcOffset();
    return moment(time, inputFormat).add(localUTCOffset - store.getters.getUser.facility_UTCOffset, 'hours');
  }
};
